/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { CommentContainer_comment$ref } from "./CommentContainer_comment.graphql";
import { ReactionButtonContainer_comment$ref } from "./ReactionButtonContainer_comment.graphql";
import { UserTagsContainer_comment$ref } from "./UserTagsContainer_comment.graphql";
import { UsernameWithPopoverContainer_comment$ref } from "./UsernameWithPopoverContainer_comment.graphql";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "EDIT" | "REJECT" | "%future added value";
declare const _AnsweredCommentContainer_comment$ref: unique symbol;
export type AnsweredCommentContainer_comment$ref = typeof _AnsweredCommentContainer_comment$ref;
export type AnsweredCommentContainer_comment = {
    readonly id: string;
    readonly author: {
        readonly id: string;
        readonly username: string | null;
    } | null;
    readonly parent: {
        readonly author: {
            readonly username: string | null;
        } | null;
        readonly " $fragmentRefs": CommentContainer_comment$ref;
    } | null;
    readonly body: string | null;
    readonly createdAt: string;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly replyCount: number;
    readonly " $fragmentRefs": UsernameWithPopoverContainer_comment$ref & ReactionButtonContainer_comment$ref & UserTagsContainer_comment$ref;
    readonly " $refType": AnsweredCommentContainer_comment$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "username",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "AnsweredCommentContainer_comment",
        "type": "Comment",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "parent",
                "storageKey": null,
                "args": null,
                "concreteType": "Comment",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "author",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/)
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "CommentContainer_comment",
                        "args": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "body",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "replyCount",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "FragmentSpread",
                "name": "UsernameWithPopoverContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ReactionButtonContainer_comment",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "UserTagsContainer_comment",
                "args": null
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastViewerAction",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '661c7f658de7a503d005944bf776800d';
export default node;
